export const AUTH_AD_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGINAS = 'AUTH_LOGINAS';
export const AUTH_OIDC = 'AUTH_OIDC';
export const AUTH_LOCAL_LOGIN = 'AUTH_LOCAL_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const INIT_STATE = 'INIT_STATE';
export const PERSIST_REDIRECT = 'PERSIST_REDIRECT';
export const CLEAR_REDIRECT = 'CLEAR_REDIRECT';
